module.exports = __webpack_public_path__ + "static/media/investorsDarkDesktop.c8903be4.png";